/**
 * Safe JSON parse/stringify helpers for PowerSync TEXT columns
 * that store serialized JSON (e.g., schema, validation_schema).
 */

/**
 * Safely parse a JSON TEXT column from PowerSync SQLite.
 * Returns fallback on parse failure; logs error for debugging.
 */
export function parseJsonText<T>(value: string | null | undefined, fallback: T): T {
  if (value == null || value === '') return fallback;
  try {
    return JSON.parse(value) as T;
  } catch (err) {
    console.error('[parseJsonText] Failed to parse JSON:', err, { value: value?.slice(0, 100) });
    return fallback;
  }
}

/**
 * Stringify a value for storage in a PowerSync TEXT column (maps to Postgres jsonb).
 */
export function stringifyJson(value: unknown): string {
  return JSON.stringify(value);
}
